import React from 'react';
import classnames from 'classnames';
import Color from 'color';
import { I as Icon } from './Icon-8KKXFsxm.js';

var styles = {"avatar":"WniTNadEyPk-","large":"_8Pqn2uZpaZg-","small":"S-edTXYA-7E-","isDark":"S1iBGElfOUA-","initials":"ErPhpHHpiBQ-","smallInitials":"aC-d-mngrIc-","hasBorder":"nR0S-GzjDnQ-"};

function isDark(colorToCheck) {
    if (colorToCheck == undefined) {
        return false;
    }
    if (colorToCheck) {
        try {
            return Color(deconstructCssCustomProperty(colorToCheck)).isDark();
        }
        catch (err) {
            console.log(err);
        }
    }
    return false;
}
function deconstructCssCustomProperty(color) {
    if (!color) {
        return;
    }
    if (!color.toLowerCase().startsWith("var(")) {
        return color;
    }
    /**
     * Rips apart the `var(--custom-property)` into just `--custom-property`.
     */
    const customProperty = color
        .replace("var(", "")
        .slice(0, -1)
        .split(" ")
        .join("");
    return getComputedStyle(document.documentElement)
        .getPropertyValue(customProperty)
        .trim();
}

function Avatar({ imageUrl, name, initials, size = "base", color, }) {
    const style = {
        backgroundColor: color,
        borderColor: color,
    };
    if (imageUrl) {
        style.backgroundImage = `url(${imageUrl})`;
    }
    const shouldBeDark = color == undefined || isDark(color);
    const className = classnames(styles.avatar, size !== "base" && styles[size], {
        [styles.hasBorder]: imageUrl && color,
        [styles.isDark]: shouldBeDark,
    });
    return (React.createElement("div", { className: className, style: style, role: imageUrl && "img", "aria-label": name }, !imageUrl && (React.createElement(Initials, { initials: initials, dark: shouldBeDark, iconSize: size }))));
}
function Initials({ initials, dark = false, iconSize = "base", }) {
    if (!initials) {
        return (React.createElement(Icon, { name: "person", color: dark ? "white" : "blue", size: iconSize }));
    }
    const className = classnames(styles.initials, {
        [styles.smallInitials]: initials.length > 2,
    });
    return React.createElement("span", { className: className }, initials.substr(0, 3));
}

export { Avatar as A };
